module.exports = __webpack_public_path__ + "static/media/paperclip-icon.a62092ac.svg";